import * as React from 'react';
import Tooltip from 'antd/lib/tooltip';
import { runwayColors } from '../styles/globalStyles';

const BADGE_SPACING = 8;

interface AttentionBadgeProps {
    tooltip: React.ReactNode;
    color?: string;
    placement?: 'left' | 'right';
}

export const AttentionBadge: React.FC<AttentionBadgeProps> = ({
    tooltip,
    color = runwayColors.statusRed,
    placement = 'left',
}) => (
    <Tooltip title={tooltip} placement="right">
        <span
            data-testid="attention-badge"
            style={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: color,
                ...(placement === 'left' ? { marginRight: BADGE_SPACING } : { marginLeft: BADGE_SPACING }),
                flexShrink: 0,
            }}
        />
    </Tooltip>
);
